<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder='Search by "searchable"'
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="[filterEndDate, filterStartDate]"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="account-period-type">Tipo de data</label>
          <select v-model="query.periodType" id="account-period-type" class="form-control">
            <option value="created_at">Criado em</option>
            <option value="updated_at">Atualizado em</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="account-start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="account-end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="account-end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th></th>
              <th>App</th>
              <th>Status</th>
              <th>Kind</th>
              <th>Fase</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Criado por</th>
              <th>Requisitado por</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>
                {{ order.id }}
              </td>
              <td>
                <CopyIcon @click="clipboardUUID(order.uuid)" class="fd-icon ml-1" v-tooltip.right="'Copiar UUID'"/>
              </td>
              <td>{{ order.appName }}</td>
              <td>{{ showStatus(order.status) }}</td>
              <td>{{ order.kind }}</td>
              <td>{{ order.stageName }}</td>
              <td>{{ order.createdAt | datetime }}</td>
              <td>{{ order.updatedAt | datetime }}</td>
              <td>{{ order.createdBy }}</td>
              <td>{{ order.requestedBy }}</td>
              <td>
                <button @click="show(order)" class="btn btn-outline">
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ModalDetail v-model="showModal" :order="currentOrder" header="Request"/>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'

import GetUser from '@/mixins/GetUser'
import Pagination from '@/components/shares/specialTag/Pagination'

import ModalDetail from './ModalDetail'

import {Filter} from '@/models/filter'
import {ChevronDownIcon, CopyIcon, SearchIcon} from 'vue-feather-icons'

const mapStatus = {
  '0': 'unprocessed',
  '1': 'processing',
  '200': 'processed',
  '300': 'processed/system_error',
  '400': 'processed/user_error',
  '500': 'error',
}

export default {
  components: {BadgeFilters, ChevronDownIcon, CopyIcon, ModalDetail, Pagination, SearchIcon},
  computed: {
    orders() {
      return this.getModels || []
    }
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.find()
  },
  data: () => ({
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    currentOrder: {},
    showModal: false,
    nameModel: 'Order',
    orderBy: 'created_at',
  }),
  methods: {
    buildPath() {
      return `${this.currentPath}/${this.entityOrder.id}/orders`
    },
    find() {
      this.asyncTemplateSelect()
    },
    showStatus(status) {
      return mapStatus[status]
    },
    clipboardUUID(uuid) {
      navigator.clipboard.writeText(uuid)
    },
    show(order) {
      this.showModal = true
      this.currentOrder = order
    }
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminManagerConsultsRequests',
  props: {
    entityOrder: {required: true, type: Object},
    currentPath: {required: true, type: String}
  },
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>
